import _ from 'lodash';
import LoadingScreen from '../../minimals/LoadingScreen';
import { useSelector } from 'react-redux';
import { generatePath, Navigate } from 'react-router';
import { PATH_AUTH, PATH_PAGE } from 'src/routes/paths';
import {
  currentWorkspaceSelectors,
  userSelectors,
  workspaceSelectors,
} from 'src/selectors';

export default function WorkspaceGuard({ children }) {
  const isAuthenticated = useSelector(userSelectors.isAuth());
  const hasWorkspaces = useSelector(workspaceSelectors.hasWorkspaces);
  const isWorkspaceLoading = useSelector(
    workspaceSelectors.isWorkspaceLoading()
  );
  const currentWorkspaceId = useSelector(
    currentWorkspaceSelectors.getCurrentWorkspaceId()
  );

  if (!isAuthenticated) {
    return <Navigate to={PATH_AUTH.root} />;
  }

  if (isWorkspaceLoading) {
    return <LoadingScreen />;
  }

  if (hasWorkspaces) {
    if (_.isEmpty(currentWorkspaceId)) {
      return <Navigate to={PATH_PAGE.workspaces} />;
    }

    return (
      <Navigate
        to={generatePath('/workspace/:workspaceId/dashboard', {
          workspaceId: currentWorkspaceId,
        })}
      />
    );
  }

  return <>{children}</>;
}
